import React, {Component, Fragment} from 'react';
import FaceMatchPage from "./Pages/FaceMatchPage";
class App extends Component {
    render() {
        return (
            <Fragment>
              <FaceMatchPage/>
            </Fragment>
        );
    }
}
export default App;